import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[appAccordionLazy]',
  standalone: true,
})
export class AccordionLazyDirective {
  content = inject<TemplateRef<any>>(TemplateRef);
}
